import CustomTraceabilityList from '../../components/CustomTraceabilityList';

const TraceabilityList = () => {
  return <CustomTraceabilityList normative="ehe" />;
};

export default TraceabilityList;
